export type TermsSection = {
  title?: string
  text?: string
  list?: string[]
}

export type TermsBlock = {
  title?: string
  sections?: TermsSection[]
  html?: string
}

export const terms = {
  blocks: [
    {
      title: 'Bonus Rules',
      sections: [
        {
          title: 'Loss Bonus Eligibility',
          text: 'You can claim the loss bonus if your withdrawal in the last 24 hours is lower than your total deposit.',
        },
        {
          title: 'Bonus Claim Period',
          text: 'Bonuses not requested within 24 hours are automatically cancelled.',
        },
        {
          title: 'Bonus Claim Conditions',
          text: 'To request a bonus:',
          list: [
            'You must have no open bets.',
            'Your account balance must be zero.',
            'You must not have a pending withdrawal request.',
          ],
        },
        {
          title: 'Bonus Calculation',
          text: 'Loss bonus is calculated as the difference between deposits and withdrawals.',
        },
        {
          title: 'Excluded Losses',
          text: 'Losses from bets placed with bonus balance are not included in the loss calculation.',
        },
        {
          title: 'Slot Games Wagering Requirement',
          text: 'Casino loss bonuses must be wagered 1x on slot games to become withdrawable.',
        },
        {
          title: 'Maximum Conversion Limit',
          text: 'The maximum amount that can be converted to real money is limited to 10x the bonus amount.',
        },
        {
          title: 'Bonus Expiry',
          text: 'Bonuses must be wagered within 72 hours of being credited. Expired bonuses are voided.',
        },
        {
          title: 'Minimum Deposit Requirement',
          text: 'Minimum deposit to qualify for loss bonus is ₺100.',
        },
        {
          title: 'Combining Bonuses',
          text: 'Only one bonus can be active at a time.\n A new promotion cannot be applied until the current one is completed.',
        },
        {
          title: 'Company Evaluation Right',
          text: 'Bonus claims may be approved or rejected based on user history and system status.',
        },
        {
          title: 'Bonus Abuse',
          text: 'Users found to be abusing bonuses:',
          list: [
            'Will have bonuses cancelled.',
            'May have accounts suspended or permanently closed.',
            'May forfeit any bonus winnings.',
          ],
        },
      ],
    },
    {
      title: 'Live Casino and Casino Wagering Rules',
      sections: [
        {
          title: 'Invalid Bets (Not Counted for Wagering)',
          text: `
            Double chance bets: e.g., Red/Black, Even/Odd, Player/Banker, etc.\n
            Bets covering all outcomes.\n
            On roulette, bets are only counted up to a maximum of 21 numbers.
          `,
        },
        {
          title: 'Live Casino Real Money Wagering',
          text: 'Only 10% of live casino wagers count towards wagering requirements.',
        },
        {
          title: 'Casino Real Money Wagering',
          list: [
            'One playthrough is sufficient.',
            'Slot games contribute 100%.',
            'Roulette: 10%.',
            'Blackjack and Poker: 20%.',
          ],
        },
      ],
    },
    {
      title: 'Sports Bonus Wagering Rules',
      sections: [
        {
          text: 'If a bet is cashed out or placed on ineligible bet types before wagering is complete, both bonus and winnings will be void. Withdrawals are allowed up to 10x the deposit when using a bonus.',
        },
      ],
    },
    {
      title: 'Wagering Requirements:',
      sections: [
        {
          title: '200% First Deposit & Special Bonuses',
          text: 'Total balance must be wagered 10x.',
          list: ['Single bet minimum odds: 2.20.', 'Combo bet minimum odds: 1.90 (per event).'],
        },
        {
          title: '100% Bonuses (e.g., Weekend, Combo, UEFA, NBA, E-sports, Birthday)',
          list: ['Single bet minimum odds: 2.00.', 'Combo bet minimum odds: 1.80.'],
        },
      ],
    },
    {
      title: 'Withdrawal Rules and Limits',
      sections: [
        {
          title: 'Daily Withdrawal Limit (Loss Bonus)',
          text: 'Only 1 withdrawal allowed per day if using loss bonus. A new withdrawal can be made only after 24 hours.',
        },
        {
          title: 'Maximum Daily Withdrawal',
          text: `
            Max per transaction: ₺100,000\n
            Max 3 withdrawals per day\n
            Minimum 4 hours between each withdrawal.
          `,
        },
        {
          title: 'KYC – Identity Verification',
          text: 'Verification may be required to withdraw bonus winnings. Company reserves the right to request documents if needed.',
        },
      ],
    },
    {
      title: 'General Warnings',
      sections: [
        {
          title: 'Negative Behavior',
          text: 'Accounts of users who act abusively may be permanently closed.',
        },
        {
          title: 'Technical Issues',
          text: `
            In case of system errors (lagging games, delayed deposits), users must provide screenshots and transaction history.\n
            Bonus durations or conditions may be re-evaluated in such cases.
          `,
        },
      ],
    },
  ] as TermsBlock[],
}
